import { Component, OnInit } from '@angular/core';
import { ThemeService } from './common/theme.service';
import { AuthService } from './services/auth.service';
import { environment } from 'src/environments/environment';
import { SharedService } from './services/shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImportStatusModelComponent } from './pages/customer-management/import-status-model/import-status-model.component';
import { CustomerService } from './services/customer.service';
import { SystemRole } from './variables/constant';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'Bertelsmann - CVT Web';
  companyCode = localStorage.getItem('company_code');
  isImportedStarted: boolean = false;

  constructor(
    private themeService: ThemeService,
    private sharedService: SharedService,
    private activeModal: NgbModal,
    private customerService: CustomerService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const currentUser = this.authService.currentUserValue;

    let domain = '';
    if (environment.production) {
      domain = window.location.hostname;
    } else {
      domain = 'http://prh.domain.com';
    }
    let subdomain = this.getSubdomain(domain);
    localStorage.setItem('company_code', subdomain);
    this.themeService.loadTheme(subdomain);

    // let check_export_customers = localStorage.getItem("export_customers");
    // if (check_export_customers && check_export_customers == "1") {
    //   this.isImportedStarted = true;
    // }

    setTimeout(() => {
      if (this.router.url != '/eCert') {
        if (currentUser && (this.authService.userRole$ == SystemRole.ADMIN || this.authService.userRole$ == SystemRole.COMPANYADMIN)) {
          this.customerService
            .importCustomerStatus(this.companyCode)
            .subscribe((res: any) => {
              if (res?.result == 'InProcess') {
                this.isImportedStarted = true;
              } else {
                this.isImportedStarted = false;
                localStorage.removeItem("export_customers");
                localStorage.removeItem("export_seconds");
              }
            }, (error) => {
              this.isImportedStarted = false;
              localStorage.removeItem("export_customers");
              localStorage.removeItem("export_seconds");
            })

          this.sharedService._isImportedS.subscribe((res) => {
            if (res) {
              this.isImportedStarted = true;
            } else {
              this.isImportedStarted = false;
              localStorage.removeItem("export_customers");
              localStorage.removeItem("export_seconds");
            }
          })

          this.sharedService._isCompletedS.subscribe((res) => {
            if (res) {
              this.openImportedCustomerModal(res);
            }
          })
        }
      }
    });
  }

  /**
   * This TypeScript function extracts the subdomain from a given domain string.
   */
  getSubdomain(url: string): string {
    const regex = /^(?:https?:\/\/)?([^\/?.]+)/;
    const match = url.match(regex);
    return match ? match[1].split('.')[0] : '';
  }


  openImportedCustomerModal(result) {
    const modalRef = this.activeModal.open(ImportStatusModelComponent,
      {
        centered: true,
        size: 'xl',
        scrollable: true,
        ariaLabelledBy: 'import-status-modal-title'
      });

    modalRef.componentInstance.customersData = result;
    modalRef.result.then(
      (data: any) => {

      },
      (reason: any) => { }
    );
  }
}

